<template>
  <!-- 编辑数据 -->
  <div v-if="editFlag" class="item-div">
    <div style="padding-bottom: 8px;">
      <a-button @click="handleAdd()" type="primary" icon="plus" style="margin-right:10px" :disabled="maxNum > 0 && dataSource.length >= maxNum">新增</a-button>
      <a-button @click="batchDel()" type="primary" icon="delete" :disabled="selectionRows.length == 0">删除</a-button>
    </div>

    <a-table
      ref="tabRef"
      size="small"
      :scroll="{x:1135}"
      bordered
      :rowKey="(record) => { return record.tmpId }"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        columnWidth: 40,
        fixed: true,
        onChange: onSelectChange
      }"
    >
      <!-- 列表字段渲染 -->
      <template v-for="item in fieldData" :slot="item.index" slot-scope="text,record">
        <!-- 日期选择框 -->
<!--        <a-date-picker v-if="item.type=='date'" valueFormat="YYYY-MM-DD" v-model="record[item.index]" placeholder="请选择日期" :disabled="!item.edit" />-->
        <DatePickerWithtoNow
          v-if="item.type=='date'"
          :key="`${record.tmpId}_${item.index}_date`"
          v-model="record[item.index]"
          :disabled="!item.edit"
          @change="changeDate(record, item.index, $event)"
        />
        <!-- 数字输入框 -->
        <a-input
          v-if="item.type == 'number'"
          :key="`${record.tmpId}_${item.index}_number`"
          type="number"
          v-model="record[item.index]"
          :disabled="!item.edit"
          placeholder="请输入"
          :min="0"
        />
        <!-- 单选框 -->
        <j-dict-select-tag
          v-if="item.type == 'radio'"
          :key="`${record.tmpId}_${item.index}_radio`"
          type="radio"
          v-model="record[item.index]"
          :disabled="!item.edit"
          :dictCode="item.dictCode"
        />
        <!-- 下拉选择 -->
        <j-dict-select-tag
          v-if="item.type == 'select'"
          :key="`${record.tmpId}_${item.index}_select`"
          type="select"
          v-model="record[item.index]"
          :disabled="!item.edit"
          :dictCode="item.dictCode"
          placeholder="请选择"
        />
        <!-- 下拉多选 -->
        <j-multi-select-tag
          v-if="item.type == 'mutiSelect'"
          :key="`${record.tmpId}_${item.index}_multi`"
          type="multi"
          v-model="record[item.index]"
          :disabled="!item.edit"
          :dictCode="item.dictCode"
          placeholder="请选择"
        />
        <!-- 文本输入框 -->
        <a-input
          v-if="item.type == 'text'"
          :key="`${record.tmpId}_${item.index}_text`"
          v-model="record[item.index]"
          placeholder="请输入"
          :disabled="!item.edit"
          allowClear
        />
      </template>
    </a-table>
  </div>

  <!-- 预览数据 -->
  <div v-else class="item-div">
    <a-table
        ref="tabRef"
        size="small"
        :scroll="{x:1135}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
    >
    </a-table>
  </div>
</template>

<script>
import DatePickerWithtoNow from './DatePickerWithtoNow'

export default {
  name: 'ItemListTable',
  components: {
    DatePickerWithtoNow
  },
  props: {
    fieldData: Array, // 列表字段属性
    itemColumn: Array, // 列表字段
    editFlag: {
      type: Boolean,
      default: false
    },
    minNum: {
      type: Number, // 最小限制数量
      default: 0
    },
    maxNum: {
      type: Number, // 最大限制数量
      default: 0
    }
  },
  data () {
    return {
      description: '采集子项详情页面',
      businessId: this.$route.query.projectId,
      dataSource: [],
      politicalOptions: [], // 政治面貌
      // 表头
      columns: [],
      indexColumn: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 40,
          hidden: !this.editFlag,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        }
      ],
      selectedRowKeys: [],
      selectionRows: [],
      editingKey: '',
      loading: false
    }
  },
  watch: {
    itemColumn: {
      handler (newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.columns = this.indexColumn.concat(newVal)
        }
      },
      immediate: true
    },
    editFlag(val) {
      this.editFlag = val
    },
    minNum(val) {
      this.minNum = val
    },
    maxNum(val) {
      this.maxNum = val
    }
  },
  methods: {
    // 处理日期变化
    changeDate(record, fieldName, value) {
      record[fieldName] = value
      // 设置日期值
      // this.$set(record, fieldName, value)
    },

    // 表格记录勾选事件
    onSelectChange (selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },

    // 新增
    handleAdd () {
      let length = this.dataSource.length
      let tmpRow = {
        index: length,
        tmpId: Math.random().toString(36).substring(2, 10),
        editable: true
      }
      this.dataSource.splice(length, 0, tmpRow)
      this.editingKey = tmpRow.tmpId
    },

    // 编辑
    handleEdit (record) {
      record.editable = true
      this.editingKey = record.tmpId
    },

    // 删除
    handleDel (record) {
      this.dataSource = this.dataSource.filter(res => {
        return res.tmpId !== record.tmpId
      })
      if (record.id) {
        this.$emit('getDelIds', record.id)
      }
    },

    // 批量删除
    batchDel () {
      this.loading = true
      let delIds = this.selectedRowKeys.join(',')
      if (this.selectedRowKeys.length > 0) {
        this.selectedRowKeys.forEach(res => {
          this.dataSource = this.dataSource.filter(record => {
            return record.tmpId !== res
          })
        })
        this.$emit('getDelIds', delIds)
      } else {
        this.$message.error('请至少选择一条记录')
      }
      this.loading = false
    }
  }
}
</script>
<style scoped lang="css">
.item-div {
  padding: 10px;
}
/* 定义滚动条的样式 */
.item-div >>> .ant-table-body::-webkit-scrollbar {
  width: 1px; /* 设置滚动条的宽度 */
  height: 5px;
}
/* 定义滚动条滑块的样式 */
.item-div >>> .ant-table-body::-webkit-scrollbar-thumb {
  background-color: #cbcaca; /* 设置滑块的背景颜色 */
  border-radius: 5px; /* 设置滑块的圆角 */
}
/* 定义滚动条轨道的样式 */
.item-div >>> .ant-table-body::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* 设置轨道的背景颜色 */
  border-radius: 5px; /* 设置轨道的圆角 */
}
.item-div >>> .ant-table-tbody tr {
  height: 31px;
}

.item-div >>> .ant-table-thead th {
  height: 31px;
  font-weight: bold;
  padding: 4px 8px !important;
  background-color: #fafafa !important;
}

.item-div >>> .ant-table-tbody td {
  padding: 4px 6px !important;
}

.item-div >>> .ant-table-tbody input {
  font-size: 13px !important;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/components/ItemListTable.vue